import React, { useId } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { reportBodySx } from './clientReportStyles';

export default function ClientReportDetails({ title, children, defaultExpanded = false }) {
  const id = useId();
  return (
    <Accordion
      disableGutters
      defaultExpanded={defaultExpanded}
      TransitionProps={{ unmountOnExit: true }}
      sx={{
        minWidth: 0,
        bgcolor: '#fff',
        color: '#334155',
        boxShadow: 'none',
        border: '1px solid #e2e8f0',
        borderRadius: '10px !important',
        '&:before': { display: 'none' },
      }}
    >
      <AccordionSummary
        id={`${id}-label`}
        aria-controls={`${id}-content`}
        expandIcon={<ExpandMoreRoundedIcon sx={{ color: '#475569' }} />}
        sx={{ minHeight: 44, px: 1.5, '&.Mui-focusVisible': { outline: '2px solid #2563eb' } }}
      >
        <Typography sx={{ fontSize: '0.8rem', fontWeight: 700 }}>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ px: 1.5, pt: 0, pb: 1.5, minWidth: 0, '& .MuiTypography-body2': reportBodySx }}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
}
